/***
 * 创建人：但志强
 * 时间：2019-06-11
 * 描述：创建和销毁工作流组件的服务
 * 更新说明:
 */
import { Injectable, ApplicationRef, Injector, ComponentFactoryResolver } from '@angular/core';
import { SwWorkFlowComponent } from './sw-work-flow.component';

@Injectable()
export class SwWorkFlowService {

    constructor(private injector: Injector,
        private applicationRef: ApplicationRef,
        private componentFactoryResolver: ComponentFactoryResolver) { }

    showWorkFlow(FromId: any) {
        //创建组件节点
        const workFlow = document.createElement("sw-work-flow");
        //获取组件信息
        const factory = this.componentFactoryResolver.resolveComponentFactory(SwWorkFlowComponent);
        //创建组件
        const SwWorkFlowComponentRef = factory.create(this.injector, [], workFlow);
        this.applicationRef.attachView(SwWorkFlowComponentRef.hostView);
        SwWorkFlowComponentRef.instance.voted.subscribe(() => {
            //销毁组件
            document.body.removeChild(workFlow);
            this.applicationRef.detachView(SwWorkFlowComponentRef.hostView);
            SwWorkFlowComponentRef.destroy()
        });
        //传递参数
        SwWorkFlowComponentRef.instance.fromId = FromId;
        SwWorkFlowComponentRef.instance.isHide = false;

        document.body.appendChild(workFlow);
    }
}
